<template>
    <a
        class="lds-widget-card"
        target="_blank"
        :href="offer.url"
        :class="offerClasses(offer.params.advantage)"
    >
        <ShowcaseOffersAdvantage
            v-if="uspPlacement === advantagesPlacement.OUTSIDE && offer.params.advantage"
            :advantage="offer.params.advantage.string"
        />
        <div class="lds-widget-card__wrapper">
            <ShowcaseOffersAdvantage
                v-if="uspPlacement === advantagesPlacement.INSIDE && offer.params.advantage"
                :advantage="offer.params.advantage.string"
            />
            <div class="lds-widget-card__row">
                <div class="lds-widget-card__container">
                    <div class="lds-widget-card__img">
                        <img
                            :src="offer.logoUrl"
                            :alt="offer.siteName"
                        >
                    </div>
                    <div class="lds-widget-card__params">
                        <div
                            class="lds-widget-card__block"
                            v-if="offer.params.cashback || offer.params.maintenance"
                        >
                            <ShowcaseOfferParams
                                v-if="offer.params.cashback"
                                :name="offer.params.cashback.name"
                                :value="offer.params.cashback.string"
                                class="lds-widget-card__item_cashback"
                            />
                            <ShowcaseOfferParams
                                v-if="offer.params.maintenance"
                                :name="offer.params.maintenance.name"
                                :value="offer.params.maintenance.string"
                                class="lds-widget-card__item_maintenance"
                            />
                            <ShowcaseOfferParams
                                v-if="offer.params.interestOnAccount && !offer.params.maintenance"
                                :name="offer.params.interestOnAccount.name"
                                :value="offer.params.interestOnAccount.string"
                                class="lds-widget-card__item_interest-on-account"
                            />
                        </div>
                        <div class="lds-widget-card__block">
                            <ShowcaseOfferParams
                                v-if="offer.params.interestOnAccount && offer.params.maintenance"
                                :name="offer.params.interestOnAccount.name"
                                :value="offer.params.interestOnAccount.string"
                                class="lds-widget-card__item_interest-on-account"
                            />
                        </div>
                    </div>
                </div>
                <span class="se-btn lds-widget-card__btn">{{ textBtn }}</span>
            </div>
        </div>
    </a>
</template>

<script setup>
import ShowcaseOffersAdvantage from '../ShowcaseOfferParams/ShowcaseOffersAdvantage.vue';
import ShowcaseOfferParams from '../ShowcaseOfferParams/ShowcaseOfferParams.vue';
import commonProps from '../../common/сommonProps.js';
import advantagesPlacement from '../../common/advantagesPlacement.js';
// import { cookieStore } from '@/scripts/cookie.ts';
import showcaseOfferClasses from '../../common/showcaseOfferClasses.js';
import {inject} from "vue";

const props = defineProps({
    offer: {
        type: Object,
        required: true,
    },
    ...commonProps(),
});

const { offerClasses } = showcaseOfferClasses(props);
const currencySymbol = inject('currencySymbol');
function transformUrl(url) {
    return cookieStore.transformUrl(url);
}

</script>
<style lang="scss" scoped>
@import '../../assets/styles/design1/offer';
</style>